/**
 * Right-panel tab ids for the user-tests feature. Shared between the manifest
 * (which registers the panel views) and the center views (which open/focus them
 * via `useLayoutStore`). Keep in sync with `manifest.ts`.
 */

/** Mini-form of the planning item selected in the detail view — see `AdminUserTestPlanningItemView`. */
export const USER_TEST_PLANNING_ITEM_TAB = 'admin-user-test-planning-item';
